import React, { useState } from 'react';
import {
  Box, Button, Flex, FormControl, Input, Text, Heading, Link,
  useToast,
} from '@chakra-ui/react';
import { loginUser } from '../api';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const toast = useToast();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // Login and store token
      const data = await loginUser(email, password, rememberMe);
      const token = data.access_token;
      localStorage.setItem('token', token);

      // Fetch user info to get role
      const userRes = await axios.get(`${API_BASE}/auth/me`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const user = userRes.data;
      localStorage.setItem('plan', user.role); // ⭐ Store plan level

      toast({ title: 'Login successful', status: 'success', duration: 2000 });
      navigate('/dashboard');
    } catch (error) {
      toast({
        title: 'Login failed',
        description: error.message || 'Please check your credentials.',
        status: 'error',
      });
    }
  };

  return (
    <Flex height="100vh" align="center" justify="center" bg="gray.50">
      <Flex width="80%" maxW="1000px" boxShadow="lg" borderRadius="lg" overflow="hidden">
        <Box bg="brand.500" color="white" p={10} width="50%">
          <Text fontSize="sm" opacity={0.6}>SK</Text>
          <Heading mb={4}>ShelfKey</Heading>
          <Text>Your Sales Ops Toolkit, Reimagined with AI</Text>
        </Box>
        <Box bg="gray.50" p={10} width="50%">
          <Heading mb={6}>Welcome Back</Heading>
          <form onSubmit={handleSubmit}>
            <FormControl mb={4}>
              <Input
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </FormControl>
            <FormControl mb={2}>
              <Input
                type="password"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </FormControl>

            {/* 👇 Forgot password link, right under password input */}
            <Box textAlign="right" mb={4}>
              <Link href="/forgot-password" color="brand.500" fontSize="sm">
                Forgot your password?
              </Link>
            </Box>

            <FormControl display="flex" alignItems="center" mb={4}>
              <input
                type="checkbox"
                checked={rememberMe}
                onChange={(e) => setRememberMe(e.target.checked)}
                style={{ marginRight: "8px" }}
              />
              <Text fontSize="sm">Remember me</Text>
             </FormControl>

            <Button type="submit" colorScheme="green" width="100%">
              Continue
            </Button>
          </form>
          <Text mt={4}>
            Don’t have an account? <Link href="/register" color="brand.500">Sign up</Link>
          </Text>
        </Box>
      </Flex>
    </Flex>
  );
};

export default Login;
